import { Button, ConfigProvider, theme } from 'antd';
import { useTranslation } from 'react-i18next';

const BackTo2DConfirm = ({ message, onClose, onSuccess }) => {
  const { t } = useTranslation('ViewerTool');

  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          fontSize: 12,
          borderRadiusSM: 2,
          borderRadiusLG: 2,
          borderRadius: 2,
          colorPrimary: '#39C2D7',
          colorPrimaryHover: '#2799b0',
          colorText: '#fff',
          colorBgBase: '#172126',
          colorBgContainer: 'transparent',
          colorBorder: '#647a87',
          controlItemBgActiveDisabled: '#2C4654',
          controlItemBgActive: '#2C4654',
          controlOutlineWidth: 0,
          colorBgElevated: '#1F313B',
        },
        components: {
          Menu: {
            colorItemBg: 'transparent',
            colorItemBgSelected: '#2c5166',
          },
        },
      }}
    >
      <div className="warning">{t(message)}</div>
      <div className="mt-4 flex justify-end">
        <Button className="mr-2" onClick={onClose}>
          {t('Cancel')}
        </Button>
        <Button type="primary" onClick={onSuccess}>
          {t('Yes')}
        </Button>
      </div>
    </ConfigProvider>
  );
};

export default BackTo2DConfirm;
